type EscapeLayerHandler = () => void;

const escapeLayers: Array<{ id: symbol; dismiss: EscapeLayerHandler }> = [];

export const registerChatEscapeLayer = (dismiss: EscapeLayerHandler): (() => void) => {
  const layer = { id: Symbol('chat-escape-layer'), dismiss };
  escapeLayers.push(layer);

  return () => {
    const index = escapeLayers.findIndex((item) => item.id === layer.id);
    if (index >= 0) escapeLayers.splice(index, 1);
  };
};

/**
 * Dismisses only the most recently opened chat surface. Parent chat listeners
 * call this before closing a thread, conversation, or popup.
 */
export const dismissTopChatEscapeLayer = (event: KeyboardEvent): boolean => {
  if (event.key !== 'Escape' || escapeLayers.length === 0) return false;

  event.preventDefault();
  event.stopPropagation();
  escapeLayers[escapeLayers.length - 1].dismiss();
  return true;
};

/**
 * Uses the first Escape press to leave a focused chat text control. This keeps
 * text entry from accidentally closing its parent conversation; a subsequent
 * Escape can then move up the normal chat dismissal hierarchy.
 */
export const blurFocusedChatControl = (event: KeyboardEvent): boolean => {
  if (event.key !== 'Escape' || !(event.target instanceof HTMLElement)) return false;

  const target = event.target;
  const isTextControl = target.matches('input:not([type="button"]):not([type="submit"]), textarea, [contenteditable="true"]');
  if (!isTextControl || !target.closest('.chat_wrapper')) return false;

  event.preventDefault();
  event.stopPropagation();
  target.blur();
  return true;
};
